import React, {useEffect, useReducer} from "react"
import { reducer, initialState } from "./reducer"

const UserContext = React.createContext()

function UserProvider({children}) {
    const [state, dispatch] = useReducer(reducer, initialState)

    useEffect(() => {
        fetchUserData()
    }, [])

    // useEffect(() => {
    //     if (state.paymentStatus) {
    //         fetchUserData()
    //     }
    // }, [state.paymentStatus])

    function fetchUserData() {
        fetch('/me')
            .then(res => res.json())
            .then(data => {
                dispatch({type: 'setUser', payload: data})
                data.error ? dispatch({type: "setLoggedIn", payload: false}) : dispatch({type: "setLoggedIn", payload: true})
                dispatch ({type: "setLoad"})
            })
    }

    useEffect(() => {
        fetchUserData();
        fetchGames();
        fetchDailyThreeYearStats();
        fetchArticles();
        fetchArticlePicks();
        fetchAuthorPickResults();
    }, []);

    useEffect(() => {
        if (state.loggedIn) {
            fetchDailyCurrentSeasonStats();
            fetchTeamTrends();
            fetchDailyPitcherCurrentSeasonStats();
            fetchDailyPitcherThreeYearStats();
            fetchGoodHitterTrends();
            fetchBadHitterTrends();
            fetchGoodPitcherMatchupRatingTrends();
            fetchBadPitcherMatchupRatingTrends();
            fetchGoodPitcherStrikeoutRatingTrends();
            fetchBadPitcherStrikeoutRatingTrends();
            fetchDailyPitchReports();
            fetchPitchers();
            fetchUserGames();
            fetchUserGameTeamTrends();
            fetchUserGameDailyThreeYearStats();
            fetchUserGameDailyCurrentSeasonStats();
            fetchUserGameDailyPitcherThreeYearStats();
            fetchUserGameDailyPitcherCurrentSeasonStats();
        }
    }, [state.loggedIn]);

    async function fetchGames() {
        const res = await fetch('/games')

        if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }

        const data = await res.json()

        if (!Array.isArray(data)) {
            console.error("Unexpected response: ", data)
            return
        }

        dispatch({ type: "fetchGames", payload: data })
    }

    async function fetchDailyThreeYearStats() {
        const res = await fetch('/daily_three_year_stats')

        if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }

        const data = await res.json()

        if (!Array.isArray(data)) {
            console.error("Unexpected response: ", data)
            return
        }

        dispatch({ type: "fetchDailyThreeYearStats", payload: data })
    }

    async function fetchDailyCurrentSeasonStats() {
        const res = await fetch('/daily_current_season_stats')

        if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }

        const data = await res.json()

        if (!Array.isArray(data)) {
            console.error("Unexpected response: ", data)
            return
        }

        dispatch({ type: "fetchDailyCurrentSeasonStats", payload: data })
    }

    async function fetchTeamTrends() {
        const res = await fetch('/team_trends')

        if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }

        const data = await res.json()

        if (!Array.isArray(data)) {
            console.error("Unexpected response: ", data)
            return
        }

        dispatch({ type: "fetchTeamTrends", payload: data })
    }

    async function fetchDailyPitcherCurrentSeasonStats() {
        const res = await fetch('/daily_pitcher_current_season_stats')

        if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }

        const data = await res.json()

        if (!Array.isArray(data)) {
            console.error("Unexpected response: ", data)
            return
        }

        dispatch({ type: "fetchDailyPitcherCurrentSeasonStats", payload: data })
    }

    async function fetchDailyPitcherThreeYearStats() {
        const res = await fetch('/daily_pitcher_three_year_stats')

        if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }

        const data = await res.json()

        if (!Array.isArray(data)) {
            console.error("Unexpected response: ", data)
            return
        }

        dispatch({ type: "fetchDailyPitcherThreeYearStats", payload: data })
    }

    async function fetchDailyPitchReports() {
        const res = await fetch('/pitch_matchup_reports')

        if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }

        const data = await res.json()

        if (!data.reports || !Array.isArray(data.reports)) {
            console.error("Unexpected response: ", data)
            return
        }

        dispatch({ type: "fetchDailyPitchReports", payload: data.reports })
    }

    async function fetchArticles() {
        const res = await fetch('/articles')

        if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }

        const data = await res.json()

        if (!Array.isArray(data)) {
            console.error("Unexpected response: ", data)
            return
        }

        dispatch({ type: "fetchArticles", payload: data })
    }

    async function fetchArticles() {
        const res = await fetch('/articles')

        if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }

        const data = await res.json()

        if (!Array.isArray(data)) {
            console.error("Unexpected response: ", data)
            return
        }

        dispatch({ type: "fetchArticles", payload: data })
    }

    async function fetchAuthors() {
        const res = await fetch('/authors')

        if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }

        const data = await res.json()

        if (!Array.isArray(data)) {
            console.error("Unexpected response: ", data)
            return
        }

        dispatch({ type: "fetchAuthors", payload: data })

    }

    async function fetchAuthorPickResults() {
        const res = await fetch ('/authors/leaderboard')

        if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }

        const data = await res.json()

        if (!Array.isArray(data)) {
            console.error("Unexpected response: ", data)
            return
        }

        dispatch({ type: "fetchAuthorPickResults", payload: data })
    }

    async function fetchArticlePicks() {
        const res = await fetch ('/article_picks')

                if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }

        const data = await res.json()

        if (!Array.isArray(data)) {
            console.error("Unexpected response: ", data)
            return
        }

        dispatch({ type: "fetchArticlePicks", payload: data })
    }

    async function fetchGoodHitterTrends() {
        const res = await fetch('/good_hitter_trends')
        
        if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }
        
        const data = await res.json()

        if (!Array.isArray(data)) {
            console.error("Unexpected response: ", data)
            return
        }

        const trends = data
        //console.log('trends', trends)

        dispatch({ type: "fetchGoodHitterTrendsThreeYear", payload: trends.filter(ele => ele.timeframe === "three year") });
        dispatch({ type: "fetchGoodHitterTrendsCurrentSeason", payload: trends.filter(ele => ele.timeframe === "current season") });
    }

    async function fetchBadHitterTrends() {
        const res = await fetch('/bad_hitter_trends')

        if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }
        
        const data = await res.json()

        if (!Array.isArray(data)) {
            console.error("Unexpected response: ", data)
            return
        }

        const trends = data

        dispatch({ type: "fetchBadHitterTrendsThreeYear", payload: trends.filter(ele => ele.timeframe === "three year") });
        dispatch({ type: "fetchBadHitterTrendsCurrentSeason", payload: trends.filter(ele => ele.timeframe === "current season") });
    }

    async function fetchGoodPitcherMatchupRatingTrends() {
        const res = await fetch('/good_pitcher_matchup_rating_trends')

        if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }
        
        const data = await res.json()

        if (!Array.isArray(data)) {
            console.error("Unexpected response: ", data)
            return
        }

        const trends = data
        //console.log('fetchedGoodPitcherMRTrends', trends)

        dispatch({ type: "fetchGoodPitcherMatchupRatingTrendsThreeYear", payload: trends.filter(ele => ele.timeframe === "three year") });
        dispatch({ type: "fetchGoodPitcherMatchupRatingTrendsCurrentSeason", payload: trends.filter(ele => ele.timeframe === "current season") });
    }

    async function fetchBadPitcherMatchupRatingTrends() {
        const res = await fetch('/bad_pitcher_matchup_rating_trends')

        if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }
        
        const data = await res.json()

        if (!Array.isArray(data)) {
            console.error("Unexpected response: ", data)
            return
        }

        const trends = data
        
        dispatch({ type: "fetchBadPitcherMatchupRatingTrendsThreeYear", payload: trends.filter(ele => ele.timeframe === "three year") });
        dispatch({ type: "fetchBadPitcherMatchupRatingTrendsCurrentSeason", payload: trends.filter(ele => ele.timeframe === "current season") });
    }

    async function fetchGoodPitcherStrikeoutRatingTrends() {
        const res = await fetch('/good_pitcher_strikeout_rating_trends')

        if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }
        
        const data = await res.json()

        if (!Array.isArray(data)) {
            console.error("Unexpected response: ", data)
            return
        }

        const trends = data

        dispatch({ type: "fetchGoodPitcherStrikeoutRatingTrendsThreeYear", payload: trends.filter(ele => ele.timeframe === "three year") });
        dispatch({ type: "fetchGoodPitcherStrikeoutRatingTrendsCurrentSeason", payload: trends.filter(ele => ele.timeframe === "current season") });
    }

    async function fetchBadPitcherStrikeoutRatingTrends() {
        const res = await fetch('/bad_pitcher_strikeout_rating_trends')

        if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }
        
        const data = await res.json()

        if (!Array.isArray(data)) {
            console.error("Unexpected response: ", data)
            return
        }

        const trends = data

        dispatch({ type: "fetchBadPitcherStrikeoutRatingTrendsThreeYear", payload: trends.filter(ele => ele.timeframe === "three year") });
        dispatch({ type: "fetchBadPitcherStrikeoutRatingTrendsCurrentSeason", payload: trends.filter(ele => ele.timeframe === "current season") });
    }

    function fetchPitchers() {
        fetch('/pitchers')
            .then(res => res.json())
            .then (data => {
                dispatch({type: 'fetchPitchers', payload: data})
            })
    }

    async function fetchUserGames() {
        const res = await fetch('/user_games')

        if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }
        
        const data = await res.json()

        if (!Array.isArray(data)) {
            console.error("Unexpected response: ", data)
            return
        }
        
        dispatch({type: "fetchUserGames", payload: data})
    }

    async function fetchUserGameTeamTrends() {
        const res = await fetch('/user_game_team_trends')

        if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }
        
        const data = await res.json()

        if (!Array.isArray(data)) {
            console.error("Unexpected response: ", data)
            return
        }

        const trends = data

        dispatch({type: "fetchUserGameTeamTrends", payload: trends})
    }

    async function fetchUserGameDailyThreeYearStats() {
        const res = await fetch('/user_game_daily_three_year_stats')

        if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }
        
        const data = await res.json()

        if (!Array.isArray(data)) {
            console.error("Unexpected response: ", data)
            return
        }

        dispatch({type: 'fetchUserGameDailyThreeYearStats', payload: data})
    }

    async function fetchUserGameDailyCurrentSeasonStats() {
        const res = await fetch('/user_game_daily_current_season_stats')

        if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }
        
        const data = await res.json()

        if (!Array.isArray(data)) {
            console.error("Unexpected response: ", data)
            return
        }

        dispatch({type: 'fetchUserGameDailyCurrentSeasonStats', payload: data})
    }

    async function fetchUserGameDailyPitcherThreeYearStats() {
        const res = await fetch('/user_game_daily_pitcher_three_year_stats')

        if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }
        
        const data = await res.json()

        if (!Array.isArray(data)) {
            console.error("Unexpected response: ", data)
            return
        }

        dispatch({type: 'fetchUserGameDailyPitcherThreeYearStats', payload: data})
    }

    async function fetchUserGameDailyPitcherCurrentSeasonStats() {
        const res = await fetch('/user_game_daily_pitcher_current_season_stats')

        if (!res.ok) {
            console.error("API error: ", res.status)
            return
        }
        
        const data = await res.json()

        if (!Array.isArray(data)) {
            console.error("Unexpected response: ", data)
            return
        }

        dispatch({type: 'fetchUserGameDailyPitcherCurrentSeasonStats', payload: data})
    }

    function login(user) {
        dispatch({type: "login", payload: user})
    }

    function logout() {
        dispatch({type: "logout"})
    }

    function signup(user) {
        dispatch({type: "signup", payload: user})
    }

    const subscription = state.user?.subscription
    //console.log('subscription', subscription)
    let isActiveSub = false

    if (subscription?.start_date && subscription?.end_date) {
        const toYMD = (d) => d.toISOString().slice(0, 10);  // “2025-04-17”
        const todayYMD = toYMD(new Date());
        //console.log('todayYMD', todayYMD)
        //console.log('end_date', subscription.end_date)
        isActiveSub = todayYMD >= subscription.start_date && todayYMD <= subscription.end_date;
        //console.log('isActiveSub', isActiveSub)
    }

    return (
        <UserContext.Provider value={{login, logout, signup, state, dispatch, fetchUserData, fetchGames, fetchDailyThreeYearStats, fetchDailyCurrentSeasonStats, fetchTeamTrends, fetchDailyPitcherCurrentSeasonStats, fetchDailyPitcherThreeYearStats, fetchGoodHitterTrends, fetchBadHitterTrends, fetchGoodPitcherMatchupRatingTrends, fetchBadPitcherMatchupRatingTrends, fetchGoodPitcherStrikeoutRatingTrends, fetchBadPitcherStrikeoutRatingTrends, fetchUserGames, fetchPitchers, fetchUserGameTeamTrends, fetchUserGameDailyThreeYearStats, fetchUserGameDailyCurrentSeasonStats, fetchUserGameDailyPitcherThreeYearStats, fetchUserGameDailyPitcherCurrentSeasonStats, isActiveSub}}>
            {children}
        </UserContext.Provider>
    )
}

export { UserContext, UserProvider }